/**
 * Trading Workflow Showcase - Complete trading workspace
 * Demonstrates: Strategy Tester, Paper Trading, Tape Panel, Order Flow
 */
export const tradingShowcase = {
    name: "trading",
    label: "Quy trình giao dịch",
    description: "Workspace giao dịch đầy đủ: backtest, paper trade, tape reading",
    layout: { rows: 1, cols: 2 },
    charts: [
        {
            id: "btc-trading-chart",
            symbol: "BTCUSDT",
            timeframe: "5m",
            symbolLinkGroup: "C",
        },
        {
            id: "btc-trading-tape",
            symbol: "BTCUSDT",
            timeframe: "5m",
            symbolLinkGroup: "C",
        },
    ],
    defaultChartProps: {
        showToolbar: true,
        showHeader: true,
        showFooter: true,
        drawingUiEnabled: true,
        theme: "classic-dark",
        enableCVD: true,
        externalCvdSeries: [],
        darkFlowStrength: 0.75,
        darkFlowSignalType: "bullish",
        panes: [
            {
                id: "price",
                label: "Price",
                visible: true,
                heightRatio: 3,
                pinned: false,
                splitScale: false,
                tooltip: "value",
                series: [
                    { id: "price-main", type: "Candlestick", yAxis: "right" },
                    { id: "vwap", type: "VWAP", yAxis: "right" },
                ],
            },
            {
                id: "volume",
                label: "Volume",
                visible: true,
                heightRatio: 1,
                pinned: false,
                splitScale: false,
                tooltip: "value",
                series: [
                    { id: "vol-main", type: "Volume", yAxis: "right" },
                    { id: "cvd", type: "CVD", yAxis: "right" },
                ],
            },
        ],
    },
    syncSettings: {
        syncVisibleRange: true,
        syncCrosshair: true,
        syncDrawings: true,
        syncSymbolLinks: true,
        syncTimeframe: true,
        syncChartType: true,
    },
    featuredPanels: ["strategy_tester", "paper_trade", "tape"],
    activeBottomTab: "strategy_tester",
    // Trading-specific props
    showTapePanel: true,
    showPaperTradePanel: true,
    // Paper trading sizing (H4) — demo config only
    sizingMode: "fixed",
    riskPercent: 1,
    initialEquity: 10000,
};
